import { dayjs } from '@convenia/utils'
import { fullNameValidation, fullNameValidationMsg } from '@convenia/employee-organisms/SystemFields/helpers'

export default (ctx) => ({
  name: {
    type: 'text',
    label: 'Nome completo',
    placeholder: 'Nome completo',
    validation: {
      required: true,
      custom: fullNameValidation
    },
    validationMsg: fullNameValidationMsg,
    required: true,
  },

  nationalities: {
    type: 'multi-select',
    label: 'Nacionalidade (s)',
    placeholder: 'Selecione uma ou mais nacionalidades',
    validation: '',
    trackBy: 'id',
    displayBy: 'name',
    options: [],
    optionsSrc: 'nationalities',
    searchable: true,
  },

  birthStateId: {
    type: 'select',
    label: 'UF Natal',
    placeholder: 'UF Natal',
    value: '',
    displayBy: 'name',
    trackBy: 'id',
    nullable: true,
    options: [],
    optionsSrc: 'states',
    searchable: true,
    onInput: (formData, value) => {
      if (value) ctx?.getCities?.(value)

      if (formData?.birthCityId) formData.birthCityId = undefined
    },
  },

  birthCityId: {
    type: 'select',
    label: 'Cidade Natal',
    placeholder: 'Cidade Natal',
    nullable: true,
    displayBy: 'name',
    trackBy: 'id',
    optionsSrc: 'cities',
    options: [],
    searchable: true,
    isDisabled: (formData) => !formData?.birthStateId,
  },

  ethnicityId: {
    type: 'select',
    label: 'Cor/Raça',
    placeholder: 'Cor/Raça',
    displayBy: 'name',
    trackBy: 'id',
    options: [],
    optionsSrc: 'ethnicities',
    nullable: true,
  },

  genderIdentityId: {
    type: 'select',
    label: 'Gênero',
    placeholder: 'Gênero',
    nullable: true,
    displayBy: 'name',
    trackBy: 'id',
    options: [],
    optionsSrc: 'genderIdentities',
    onInput: (formData) => {
      if (formData.genderIdentityId === 1) formData.gender = 1
      else if (formData.genderIdentityId === 2) formData.gender = 2
    },
  },

  gender: {
    type: 'select',
    label: 'Gênero no Documento',
    placeholder: 'Gênero no Documento',
    validation: 'required',
    required: true,
    displayBy: 'name',
    trackBy: 'id',
    options: [
      { id: 1, name: 'Masculino' },
      { id: 2, name: 'Feminino' },
    ],
    optionsSrc: 'genders',
    hint:
      'Infelizmente o e-social não contempla as opções de gênero da plataforma. Não se preocupe que esta informação servirá apenas para nível de e-social e ninguém além de você e o RH terá acesso a ela :)',
    hide: ({ genderIdentityId: id }) => !id || id === 1 || id === 2,
  },

  socialName: {
    type: 'text',
    label: 'Nome Social',
    placeholder: 'Nome Social',
    hint:
      'Nome social é o nome que pessoas transgêneros e travestis preferem ser chamadas, e possui a mesma proteção concedida ao nome de registro. É assegurado pelo Decreto 8727/16.',
  },

  maritalStatusId: {
    type: 'select',
    label: 'Estado Civil',
    placeholder: 'Estado Civil',
    validation: '',
    displayBy: 'name',
    trackBy: 'id',
    options: [],
    optionsSrc: 'maritalStatuses',
  },

  birthday: {
    type: 'date',
    label: 'Data de nascimento',
    placeholder: 'Data de nascimento',
    enableInput: true,
    maxDate: dayjs().toDate(),
    validation: {
      custom: (_, input) => (
        dayjs(input).isValid() && dayjs(input).isSameOrBefore(dayjs().toDate())
      )
    },
    validationMsg: 'A data de nascimento não pode ser futura.',
    emitPreValidation: true,
  },

  motherName: {
    type: 'text',
    label: 'Nome da mãe',
    placeholder: 'Nome da mãe',
    validation: { custom: fullNameValidation },
    validationMsg: fullNameValidationMsg,
  },

  fatherName: {
    type: 'text',
    label: 'Nome do pai',
    placeholder: 'Nome do pai',
    validation: { custom: fullNameValidation },
    validationMsg: fullNameValidationMsg,
  }
})
